/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPage() {
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  useEffect(() => { api.get("/privacy/info").then(({ data }) => setInfo(data)).catch(() => null); }, []);
  const S = ({ title, children }) => (
    <section className="bg-white rounded-2xl border border-[#E4E0D5] p-4">
      <h2 className="font-[Fraunces] text-lg font-bold text-[#0A1426] mb-1">{title}</h2>
      <div className="text-[13px] text-[#0A1426]/80 leading-relaxed">{children}</div>
    </section>
  );
  return (
    <div className="bc-shell" data-testid="privacy-page">
      <div className="px-5 pt-5 pb-4 flex items-center gap-3">
        <button data-testid="privacy-back" onClick={() => navigate(-1)} className="w-11 h-11 grid place-items-center rounded-full bg-white border border-[#E4E0D5] text-[#0A1426]"><ArrowLeft size={20} /></button>
        <h1 className="font-[Fraunces] text-2xl font-bold text-[#0A1426]">Confidentialité</h1>
      </div>
      <div className="flex-1 overflow-y-auto bc-scroll px-5 pb-10 flex flex-col gap-3">
        <S title="Responsable du traitement">Bombacare Connect (MVP1 · Bruxelles / RDC). Données de démonstration fictives.</S>
        <S title="Données collectées">Identité (nom, téléphone, e-mail), rôle, données de santé saisies par vous ou votre aidant (tension, humeur, médicaments, séances), messages avec votre équipe de soin, informations d'abonnement (jamais vos numéros de carte, traités par Stripe).</S>
        <S title="Finalités">Suivi de rééducation, prévention de la récidive, alertes à votre équipe de soin, rappels, facturation.</S>
        <S title="Hébergement">{info?.region || "Union européenne"}. Une copie locale chiffrée reste sur votre appareil pour fonctionner hors-ligne.</S>
        <S title="Vos droits">Accès, export (format JSON), rectification, suppression définitive — disponibles dans Profil → Mes données. Retrait du consentement à tout moment.</S>
        <S title="Sous-traitants">Stripe (paiement carte), fournisseur SMS/USSD (Africa's Talking ou Twilio, si activé), hébergeur cloud UE. Un accord de traitement (DPA) est signé avec chacun.</S>
        <S title="Version">{info?.version || "—"}</S>
      </div>
    </div>
  );
}
